import "../css/style.css"
import "../../node_modules/@glidejs/glide/dist/css/glide.core.min.css"
import "../../node_modules/@glidejs/glide/dist/css/glide.theme.min.css"
import "preline"
import Glide from "@glidejs/glide"

document.addEventListener("DOMContentLoaded", () => {
    // Main Nav
    const nav = document.getElementById("masthead")
    if (nav) {
        const logo = nav.querySelector(".header-logo")
        window.addEventListener("scroll", () => {
            if (window.scrollY >= 100) {
                nav.classList.add("scrolled")
            } else {
                nav.classList.remove("scrolled")
            }
        })
    }

    const glide = new Glide(".posts-carousel", {
        type: "carousel",
        startAt: 0,
        perView: 3.5,
        focusAt: 0,
        gap: 20,
        autoplay: 5000,
        hoverpause: true,
        breakpoints: {
            768: {
                perView: 2.5,
            },
            576: {
                perView: 1.2,
            },
        },
    })
    glide.mount()

    // Stop YouTube video when modal is closed
    const modal = document.getElementById("hs-custom-backdrop-modal")
    if (modal) {
        const iframe = modal.querySelector("iframe")
        const closeModal = () => {
            const src = iframe.src
            iframe.src = src // Reset the iframe src to stop the video
        }

        // Click outside modal
        window.addEventListener("click", event => {
            if (!modal.classList.contains("active")) {
                closeModal()
            }
        })
    }
})
